import { omit, pick, values } from 'ramda';

import { SortBy } from '../../api/algolia/algolia';
import { DocumentType } from '../../types/document';
import { CLASSIFICATION, FILTER } from '../../types/filters';
import { MEDIA_TYPE } from '../../types/press-media';
import { attributeNotIn } from '../algolia/algolia-filters-builder';

const notTypeIn = attributeNotIn('type');

export const searchAll = ({ query, ...rest } = {}) => ({
  sortBy: SortBy.NONE,
  query,
  hitsPerPage: 20,
  facets: ['filters.*'],
  filters: notTypeIn([DocumentType.CONTACT, DocumentType.PROFILE]),
  facetFilters: pick(values(FILTER), rest),
});

export const searchNews = ({ query } = {}) =>
  searchAll({
    query,
    [FILTER.CLASSIFICATION]: values(
      omit(['PUBLICATION', 'INNER_PAGE'], CLASSIFICATION)
    ),
  });

export const searchMedias = ({ query } = {}) =>
  searchAll({
    query,
    [FILTER.MEDIA_TYPE]: values(omit(['PUBLICATION'], MEDIA_TYPE)),
  });
